export const isProduction = () => {
   const testEnv = ['local', 'staging'];

   const isDevelopment = testEnv.some((env) =>
      window.location.hostname.includes(env)
   );

   return !isDevelopment;
};
